'use strict';

angular.module('projectsManagement')
  .controller('NoteEditCtrl', [
    '$scope', 'noteEditingViewModel', '$$masterId', '$$noteId', '$modalInstance',
    function (scope, viewModel, $$masterId, $$noteId, $modalInstance) {
      scope.vm = new viewModel($$masterId, $$noteId, $modalInstance);
    }
  ]);